import { render, staticRenderFns } from "./approving-authority.vue?vue&type=template&id=b1a64732&"
import script from "./approving-authority.vue?vue&type=script&lang=js&"
export * from "./approving-authority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports